import React, { useEffect } from "react";

import { Link, withRouter } from "react-router-dom";
import {  MODEL, BASE_URL, INDEX_TITLE, SCOPE_ENUM, CALCULATION_TYPE_ENUM  } from "./components/consts";
import CustomDatatable from "../../../components/Common/CustomDatatable/CustomDatatable";
import FormLayout from "../../../components/Common/FormLayout";
import { useDispatch } from "react-redux";
import { setPageTitle } from "../../../store/pagetitle/actions";
import { getLabelFromArray } from "../../../helpers/array_utils";
import IndexActionButtons from "../../../components/Actions/Index/IndexActionButtons";
import CustomLink from "../../../components/Common/CustomLink";

const Index = (props) => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle(INDEX_TITLE));
  },[]);

  const columns = [
      {
        name: "Name",
        label: "Nombre",
        width: 20,
      },
      {
        label: "Ambito",
        width: 20,
      },
      {
        label: "Tipo de cálculo",
        width: 20,
      },
      {
        label: "Valor",
        width: 20,
      },
    ];

  const rows = (data) => {

    const rows = [];
    
    const r= data?.map((p, index) => {
      const fields = [];
    

      fields.push(
        <CustomLink 
        content={p.name}
        to={`${BASE_URL}/${p.id}`}>{p.name}</CustomLink>
      );
      
      fields.push(
        <span>{getLabelFromArray(p.scope,SCOPE_ENUM)}</span>
      );

      fields.push(
        <span>{getLabelFromArray(p.calculationType,CALCULATION_TYPE_ENUM)}</span>
      );
      
      fields.push(
        <span>{`${p.calculationType == 1 ? '%' : '$'} ${p.amount}`}</span>
      );

      rows.push({fields : fields});
    });

    return rows;
  };

  const actionButtons =  (
    <IndexActionButtons
      url={BASE_URL}
    />
);

  return (
    <FormLayout
      actionButtons={actionButtons}
    >
      <CustomDatatable
        model={MODEL}
        checks
        columns={columns}
        rows={rows}
        filter={{
          customFilters: [],
        }}
        defaultSort={{orderCriteria: "Name", orderDirection: 0}}
      />
    </FormLayout>
  );
};

export default withRouter(Index);
